import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import {
    Paper,
    Typography,
    Grid,
    Button,
    Snackbar,
    SnackbarContent
} from "@material-ui/core";
import {
    getJobPack,
    getNewJobPackID,
    getUsers,
    uploadFile,
    setJobPack,
    goToLink,
    getReportTypes,
    getSSWPConfigs
} from "./actions";
import {
    selectJobPack,
    selectNewJobPackID,
    selectUserInfo,
    selectReportTypes,
    selectSSWPConfigInfo
} from "./selectors";
import blankProfile from "./blankProfile";
import {
    JobPackProfileInfoWidget,
    JobPackProfileAddressWidget,
    JobPackAssignessArrayList,
    JobPackProfileUploadFilesWidget,
    JobPackProfileRelatedReportsWidget,
    JobPackSelectReportsWidget
} from "../../../widgets";
import colors from "./colors.json";
const reducer = "JobPackV2_reducer";
const relatedReportsSelector = JobPackProfileRelatedReportsWidget.createSelectors(
    reducer
);

class JobPack extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getReportTypes();
        props.getSSWPConfigs();
        let pageType = props.match.params.type;
        if (pageType === "create") {
            props.getNewJobPackID();
        } else {
            props.getJobPack(props.match.params.uid);
        }
        this.state = {
            edit: pageType === "view" ? false : true,
            pageType: pageType,
            profile: blankProfile,
            uploadSuccess: false,
            uploadFail: false
        };
        this.goBack = this.goBack.bind(this);
    }
    goBack() {
        this.props.history.goBack();
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.pageType === "create" &&
            this.state.profile.job_id !== this.props.newJobPackID
        ) {
            let profile = blankProfile;
            profile.job_id = this.props.newJobPackID;
            let colorVal =
                colors[
                    parseInt(
                        this.props.newJobPackID[
                            this.props.newJobPackID.length - 1
                        ]
                    )
                ];
            profile.calendar_color = colorVal;
            this.setState({ profile });
        } else if (
            (this.state.pageType === "view" ||
                this.state.pageType === "edit") &&
            prevProps.jobPack !== this.props.jobPack
        ) {
            this.setState({ profile: this.props.jobPack });
        }
    }
    render() {
        const { profile, edit } = this.state;
        return (
            profile && (
                <React.Fragment>
                    <Paper id="titlePaper">
                        <Typography variant="display1">
                            Job ID {profile.job_id}
                        </Typography>
                    </Paper>
                    <Grid container spacing={40}>
                        <Grid item xs={6} xl={6}>
                            <JobPackProfileInfoWidget.view
                                profile={this.state.profile}
                                edit={edit}
                                callback={(key, value) => {
                                    let profile = {
                                        ...this.state.profile,
                                        [key]: value
                                    };
                                    this.setState({ profile });
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} xl={6}>
                            <JobPackProfileAddressWidget.view
                                profile={this.state.profile}
                                edit={edit}
                                callback={(key, value) => {
                                    let profile = {
                                        ...this.state.profile,
                                        [key]: value.toString()
                                    };
                                    this.setState({ profile });
                                }}
                            />
                        </Grid>

                        <Grid item xs={6} xl={6}>
                            {this.props.users && (
                                <JobPackAssignessArrayList.view
                                    profile={this.state.profile}
                                    edit={edit}
                                    callback={(key, value) => {
                                        let profile = {
                                            ...this.state.profile,
                                            [key]: value
                                        };
                                        this.setState({ profile });
                                    }}
                                    users={this.props.users}
                                />
                            )}
                        </Grid>

                        <Grid item xs={6} xl={6}>
                            {this.props.users && (
                                <JobPackProfileUploadFilesWidget.view
                                    goToLink={this.props.goToLink}
                                    profile={this.state.profile}
                                    uploadFile={(file, callback) => {
                                        this.props.uploadFile(
                                            profile.job_id,
                                            file,
                                            progress => {
                                                callback(progress);
                                            },
                                            newState => {
                                                let attached_files = [];
                                                if (
                                                    typeof this.state.profile[
                                                        "attached_files"
                                                    ] === "undefined"
                                                )
                                                    attached_files = [newState];
                                                else
                                                    attached_files = [
                                                        ...this.state.profile[
                                                            "attached_files"
                                                        ],
                                                        newState
                                                    ];

                                                let profile = {
                                                    ...this.state.profile,
                                                    attached_files
                                                };
                                                this.setState({ profile });
                                            }
                                        );
                                    }}
                                    edit={edit}
                                    deleteFile={index => {
                                        let profile = {
                                            ...this.state.profile
                                        };
                                        profile.attached_files.splice(index, 1);
                                        this.setState({ profile });
                                    }}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} xl={12}>
                            <JobPackSelectReportsWidget.view
                                profile={this.state.profile}
                                edit={edit}
                                callback={(key, value) => {
                                    let profile = {
                                        ...this.state.profile,
                                        [key]: value
                                    };
                                    this.setState({ profile });
                                }}
                                sswpConfigs={this.props.configInfo}
                                reportTypes={this.props.reportTypes}
                            />
                        </Grid>
                    </Grid>
                    {this.state.pageType === "view" && (
                        <JobPackProfileRelatedReportsWidget.view
                            selectors={relatedReportsSelector}
                            uid={this.props.match.params.uid}
                        />
                    )}
                    <Paper
                        style={{
                            border: "1px solid black",
                            padding: 20,
                            display: "flex",
                            marginTop: 20,
                            width: "fit-content"
                        }}
                    >
                        <Button
                            style={{ marginRight: 15 }}
                            variant="contained"
                            onClick={() => {
                                this.goBack();
                            }}
                        >
                            {edit ? "Cancel" : "Jobpack Manager"}
                        </Button>

                        {edit && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.props.setJobPack(
                                        this.state.profile,
                                        success => {
                                            if (success) {
                                                this.setState({
                                                    uploadSuccess: true
                                                });
                                            } else {
                                                this.setState({
                                                    uploadFail: true
                                                });
                                            }
                                            this.goBack();
                                        }
                                    );
                                }}
                            >
                                Submit
                            </Button>
                        )}
                    </Paper>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        autoHideDuration={6000}
                        open={this.state.uploadSuccess || this.state.uploadFail}
                        onClose={() => {
                            this.setState({
                                uploadSuccess: false,
                                uploadFail: false
                            });
                        }}
                    >
                        <SnackbarContent
                            style={{
                                backgroundColor: this.state.uploadSuccess
                                    ? "green"
                                    : this.state.uploadFail
                                    ? "red"
                                    : "white",
                                color: "white"
                            }}
                            message={
                                this.state.uploadSuccess
                                    ? "Jobpack Successfully Uploaded"
                                    : this.state.uploadFail
                                    ? "Unable to Upload Jobpack, Please Contact System Admin"
                                    : ""
                            }
                        />
                    </Snackbar>
                </React.Fragment>
            )
        );
    }
}
export default hot(module)(
    connect(
        store => {
            return {
                jobPack: selectJobPack(store),
                newJobPackID: selectNewJobPackID(store),
                users: selectUserInfo(store),
                reportTypes: selectReportTypes(store),
                configInfo: selectSSWPConfigInfo(store)
            };
        },
        {
            getUsers,
            getJobPack,
            getNewJobPackID,
            uploadFile,
            setJobPack,
            goToLink,
            getReportTypes,
            getSSWPConfigs
        }
    )(JobPack)
);
